// Generated by CoffeeScript 1.6.3
(function() {
  rjm.model.CategorySelector = Backbone.RelationalModel.extend({
    initialize: function(options) {
      if (!options.hasOwnProperty("values") || !options.hasOwnProperty("labels") || !options.hasOwnProperty("column")) {
        throw "InvalidConstructorArgs - Category Selector";
      }
    },
    addValue: function(value) {
      var tmp;
      tmp = _(this.get("values")).clone();
      tmp.push(value);
      this.set({
        values: tmp
      });
    },
    removeValue: function(value) {
      this.set({
        values: _(this.get("values")).without(value)
      });
    },
    addAllValues: function() {
      this.set({
        values: [-1]
      });
    },
    relations: [
      {
        type: Backbone.HasOne,
        key: "column",
        relatedModel: "rjm.model.LSColumn",
        includeInJSON: true
      }
    ]
  });

}).call(this);
